export default {
	data(){
		return{
			file_list: [],
			notice:{}
		}
	},
	// created(){
	//
	// },
	computed: {
		upload_api(){
			const { application_hash } = this.$route.params;
			return `${process.env.VUE_APP_API_PATH}/files/upload.php/?hash=${application_hash}&category=${this.item.category}`;
		},
	},
	methods: {
		testing(x){
			if(x.size > 100000000){
				this.notice = this.$notify({
					title:'Uploading File',
					type:'error',
					message:'File size cannot exceed 100mb!'
				});
				return false;
			}

			this.notice = this.$notify({
				title:'Uploading File',
				dangerouslyUseHTMLString: true,
				message:'Just a moment... <i class="el-icon-loading"/>',
				duration:0
			});
			return true;
		},
		testingImg(x){
			if(x.size > 100000000){
				this.notice = this.$notify({
					title:'Uploading File',
					type:'error',
					message:'File size cannot exceed 100mb!'
				});
				return false;
			}

			this.notice = this.$notify({
				title:'Uploading File',
				dangerouslyUseHTMLString: true,
				message:'Just a moment... <i class="el-icon-loading"/>',
				duration:3500
			});
			return true;
		},
		onError(err){
			this.notice.close();
			console.log("error!",err.status, typeof err);

			let response = JSON.parse(err.message)
			response.errors.forEach( error => {
				let error_title = null,
				error_message = null;
				switch(error){
					case 'Invalid mimetype':
					error_title = "Invalid File Type";
					error_message = "Uploads must be PDFs for documents or JPEGs for photos.";
					break;
					case 'File size is too large':
					error_title = "File too large";
					error_message = "Uploads must be within 500mb.";
					break;
					case 'File already exists':
					error_title = "File already exists";
					error_message = "Please use unique and descriptive file names.";
					break;
					default:
					error_title = "Error";
					error_message = "Unable to upload file.";
				}
				this.$notify.error({
					title: error_title,
					message: error_message
				});
			})
		},
		async onSuccess(response, raw_file){
			this.notice.close();
			const file = { name: raw_file.name };
			await this.$store.dispatch('application/attachments/addFileToStore', { category: this.item.category, file } );

			this.$notify({
				title:'File uploaded!',
				type:'success'
			})
			this.$emit('validation-needed', this.prop); // Validate field on success
		},
		onRemove(file){
			// if(this.$confirm(`Remove ${ file.name }?`)){
			// 	return false;
			// }
			if(! confirm(`Remove ${ file.name }?`))
				return false;

			const { application_hash } = this.$route.params;
			const data = {
				hash: application_hash,
				file: file.name,
				category: this.item.category
			}
			this.$axios.post(`${process.env.VUE_APP_API_PATH}/files/delete.php`, data)
			.then( () => {
				this.$notify({
					title:'File deleted!',
					type:'success'
				})
				this.$store.dispatch('application/attachments/removeFileFromStore', { category: this.item.category, file } );
				this.$emit('validation-needed', this.prop); // Validate field on removal
			})
		},
		handleExceed(files, fileList) {
			this.$message.warning(`The limit is 3, you selected ${files.length} files this time, add up to ${files.length + fileList.length} totally`);
		},
		beforeRemove(file) {
			return this.$confirm(`Remove ${ file.name }?`);
		}
	}
}
